function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Button, Drawer, Statistic, List, Modal, notification, Alert, Tag, Space } from "antd";
import Calendar from 'react-calendar';
import { PlusSquareFill, BuildingFill, PeopleFill, BoxFill, TrashFill, PencilSquare } from "react-bootstrap-icons";
import AddAppointment from "../components/forms/AddAppointment";
import Common from "../components/includes/Common";
import EditAppointment from "../components/forms/EditAppointment";
import Moment from "react-moment";
import moment from "moment";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var Appointments = function Appointments() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    monthlyAppointments = _useState2[0],
    setMonthlyAppointments = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    upcommingAppointments = _useState4[0],
    setUpcommingAppointments = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    monthlyAppointmentsDate = _useState6[0],
    setMonthlyAppointmentsDate = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    upcomingAppointmentsDate = _useState8[0],
    setUpcomingAppointmentsDate = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    showAdd = _useState0[0],
    setShowAdd = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    showEdit = _useState10[0],
    setShowEdit = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedAp = _useState12[0],
    setSelectedAp = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    dataChanged = _useState14[0],
    setDataChanged = _useState14[1];
  var _useState15 = useState(0),
    _useState16 = _slicedToArray(_useState15, 2),
    totalMonth = _useState16[0],
    setTotalMonth = _useState16[1];
  var _useState17 = useState(0),
    _useState18 = _slicedToArray(_useState17, 2),
    totalUpcoming = _useState18[0],
    setTotalUpComing = _useState18[1];
  var _useState19 = useState(""),
    _useState20 = _slicedToArray(_useState19, 2),
    errorMessage = _useState20[0],
    setErrorMessage = _useState20[1];
  var handleDelete = function handleDelete(a) {
    setSelectedAp(a);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La suppresion du planning de ", a.reason == 0 && "visite annuelle", " ", a.reason == 1 && "preambauche", " ", a.reason == 2 && "permis de travail", " ", a.reason == 3 && "travailleur journalier", " pour la soci\xE9t\xE9 ", a.company.label, " ?"]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "deleteap", {
          user_id: Common.currentUser.id,
          id: a.id.toString()
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
          } else {
            notification.error({
              message: "Erreur!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur!",
            description: "Une erreur est survenue " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };
  useEffect(function () {
    setDataChanged(false);
    axios.get(Common.baseApiUrl + "getappointments/" + Common.currentUser.id).then(function (response) {
      setMonthlyAppointments([]);
      setUpcommingAppointments([]);
      setMonthlyAppointmentsDate([]);
      setUpcomingAppointmentsDate([]);
      if (response.data.status == 200) {
        setMonthlyAppointments(response.data.map);
        setUpcommingAppointments(response.data.uap);
        response.data.mapd.forEach(function (e) {
          setMonthlyAppointmentsDate(function (prev) {
            return [].concat(_toConsumableArray(prev), [moment(e).format("DD-MM-YYYY")]);
          });
        });
        response.data.uapd.forEach(function (e) {
          setUpcomingAppointmentsDate(function (prev) {
            return [].concat(_toConsumableArray(prev), [moment(e).format("DD-MM-YYYY")]);
          });
        });
        setTotalMonth(response.data.totalMonth);
        setTotalUpComing(response.data.totalUpcoming);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {});
  }, [dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 11,
          md: 11,
          sm: 11,
          xs: 10,
          children: /*#__PURE__*/_jsx(Calendar, {
            style: {
              height: 900,
              width: "100%"
            },
            onChange: null,
            locale: "fr-FR",
            value: null,
            tileClassName: function tileClassName(_ref) {
              var date = _ref.date,
                view = _ref.view;
              if (monthlyAppointmentsDate.find(function (x) {
                return x === moment(date).format("DD-MM-YYYY");
              }) || upcomingAppointmentsDate.find(function (x) {
                return x === moment(date).format("DD-MM-YYYY");
              })) {
                return 'highlight';
              } else {
                return 'reg_calendar_item';
              }
            },
            tileDisabled: function tileDisabled(_ref2) {
              var date = _ref2.date;
              return date.getDay() === 0;
            }
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 1,
          md: 1,
          sm: 1,
          xs: 2,
          children: /*#__PURE__*/_jsx(Button, {
            type: "link",
            onClick: function onClick() {
              setShowAdd(true);
            },
            children: /*#__PURE__*/_jsxs("b", {
              children: [" ", /*#__PURE__*/_jsx(PlusSquareFill, {
                size: 23
              })]
            })
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 11,
          md: 11,
          sm: 11,
          xs: 9,
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsxs(Col, {
              lg: 6,
              md: 6,
              sm: 6,
              children: [/*#__PURE__*/_jsx("div", {
                className: "infoBox",
                style: {
                  background: "#E1E1CD"
                },
                children: /*#__PURE__*/_jsx(Statistic, {
                  title: "TOTAL MOIS",
                  value: totalMonth
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(List, {
                itemLayout: "horizontal",
                dataSource: monthlyAppointments,
                renderItem: function renderItem(item, index) {
                  return /*#__PURE__*/_jsx(List.Item, {
                    children: /*#__PURE__*/_jsx(List.Item.Meta, {
                      avatar: /*#__PURE__*/_jsx(BoxFill, {
                        size: 28
                      }),
                      title: /*#__PURE__*/_jsx("b", {
                        children: /*#__PURE__*/_jsx(Moment, {
                          date: item.date,
                          format: "DD/MM/YYYY"
                        })
                      }),
                      description: /*#__PURE__*/_jsxs(Space, {
                        wrap: true,
                        direction: "horizontal",
                        children: [/*#__PURE__*/_jsx(BuildingFill, {
                          size: 22
                        }), /*#__PURE__*/_jsx("span", {
                          children: item.company.label
                        }), /*#__PURE__*/_jsxs(Tag, {
                          color: "#f50",
                          children: [item.reason == 0 && "VA", " ", item.reason == 1 && "PE", " ", item.reason == 2 && "PT", " ", item.reason == 3 && "TJ"]
                        }), /*#__PURE__*/_jsx(PeopleFill, {
                          size: 22
                        }), /*#__PURE__*/_jsx(Statistic, {
                          value: item.candidates_count
                        }), /*#__PURE__*/_jsxs(Tag, {
                          color: "#f50",
                          children: ["P. ", item.priority == 0 && "Faible", " ", item.priority == 1 && "Normal", " ", item.priority == 2 && "Elévée"]
                        }), /*#__PURE__*/_jsx(Button, {
                          type: "link",
                          onClick: function onClick() {
                            setSelectedAp(item);
                            setShowEdit(true);
                          },
                          children: /*#__PURE__*/_jsx("b", {
                            children: /*#__PURE__*/_jsx(PencilSquare, {
                              size: 22
                            })
                          })
                        }), /*#__PURE__*/_jsx(Button, {
                          type: "link",
                          onClick: function onClick() {
                            handleDelete(item);
                          },
                          children: /*#__PURE__*/_jsx("b", {
                            children: /*#__PURE__*/_jsx(TrashFill, {
                              size: 22
                            })
                          })
                        })]
                      })
                    })
                  });
                }
              })]
            }), /*#__PURE__*/_jsxs(Col, {
              lg: 6,
              md: 6,
              sm: 6,
              children: [/*#__PURE__*/_jsx("div", {
                className: "infoBox",
                style: {
                  background: "#E1CECC"
                },
                children: /*#__PURE__*/_jsx(Statistic, {
                  title: /*#__PURE__*/_jsx("b", {
                    children: "TOTAL A VENIR"
                  }),
                  value: totalUpcoming
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(List, {
                itemLayout: "horizontal",
                dataSource: upcommingAppointments,
                renderItem: function renderItem(item, index) {
                  return /*#__PURE__*/_jsx(List.Item, {
                    children: /*#__PURE__*/_jsx(List.Item.Meta, {
                      avatar: /*#__PURE__*/_jsx(BoxFill, {
                        size: 28
                      }),
                      title: /*#__PURE__*/_jsx("b", {
                        children: /*#__PURE__*/_jsx(Moment, {
                          date: item.date,
                          format: "DD/MM/YYYY"
                        })
                      }),
                      description: /*#__PURE__*/_jsxs(Space, {
                        wrap: true,
                        direction: "horizontal",
                        children: [/*#__PURE__*/_jsx(BuildingFill, {
                          size: 22
                        }), /*#__PURE__*/_jsx("span", {
                          children: item.company.label
                        }), /*#__PURE__*/_jsxs(Tag, {
                          color: "#f50",
                          children: [item.reason == 0 && "VA", " ", item.reason == 1 && "PE", " ", item.reason == 2 && "PT", " ", item.reason == 3 && "TJ"]
                        }), /*#__PURE__*/_jsx(PeopleFill, {
                          size: 22
                        }), /*#__PURE__*/_jsx(Statistic, {
                          value: item.candidates_count
                        }), /*#__PURE__*/_jsxs(Tag, {
                          color: "#f50",
                          children: ["P. ", item.priority == 0 && "Faible", " ", item.priority == 1 && "Normal", " ", item.priority == 2 && "Elévée"]
                        }), /*#__PURE__*/_jsx(Button, {
                          type: "link",
                          onClick: function onClick() {
                            setSelectedAp(item);
                            setShowEdit(true);
                          },
                          children: /*#__PURE__*/_jsx("b", {
                            children: /*#__PURE__*/_jsx(PencilSquare, {
                              size: 22
                            })
                          })
                        }), /*#__PURE__*/_jsx(Button, {
                          type: "link",
                          onClick: function onClick() {
                            handleDelete(item);
                          },
                          children: /*#__PURE__*/_jsx("b", {
                            children: /*#__PURE__*/_jsx(TrashFill, {
                              size: 22
                            })
                          })
                        })]
                      })
                    })
                  });
                }
              })]
            })]
          })
        })
      })]
    }), /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: "NOUVEAU PLANNING"
      }),
      width: "360px",
      open: showAdd,
      destroyOnClose: true,
      onClose: function onClose() {
        setShowAdd(false);
      },
      children: /*#__PURE__*/_jsx(AddAppointment, {
        handler: function handler() {
          setDataChanged(true);
          setShowAdd(false);
        }
      })
    }), selectedAp && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: "MODIFIER LE PLANNING"
      }),
      width: "360px",
      open: showEdit,
      destroyOnClose: true,
      onClose: function onClose() {
        setShowEdit(false);
      },
      children: /*#__PURE__*/_jsx(EditAppointment, {
        appointment: selectedAp,
        handler: function handler() {
          setDataChanged(true);
          setShowEdit(false);
        }
      })
    })]
  });
};
export default Appointments;